// Currency utilities - user-configurable currency stored in localStorage.
// Add new currencies here as needed.

export const CURRENCIES = [
  { code: 'USD', symbol: '$', locale: 'en-US', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', locale: 'de-DE', name: 'Euro' },
  { code: 'GBP', symbol: '£', locale: 'en-GB', name: 'British Pound' },
  { code: 'INR', symbol: '₹', locale: 'en-IN', name: 'Indian Rupee' },
  { code: 'AUD', symbol: 'A$', locale: 'en-AU', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', locale: 'en-CA', name: 'Canadian Dollar' },
  { code: 'BRL', symbol: 'R$', locale: 'pt-BR', name: 'Brazilian Real' },
  { code: 'MXN', symbol: 'MX$', locale: 'es-MX', name: 'Mexican Peso' },
  { code: 'ZAR', symbol: 'R', locale: 'en-ZA', name: 'South African Rand' },
  { code: 'KES', symbol: 'KSh', locale: 'en-KE', name: 'Kenyan Shilling' },
  { code: 'NGN', symbol: '₦', locale: 'en-NG', name: 'Nigerian Naira' },
  { code: 'PHP', symbol: '₱', locale: 'en-PH', name: 'Philippine Peso' },
  { code: 'IDR', symbol: 'Rp', locale: 'id-ID', name: 'Indonesian Rupiah' },
  { code: 'THB', symbol: '฿', locale: 'th-TH', name: 'Thai Baht' },
  { code: 'VND', symbol: '₫', locale: 'vi-VN', name: 'Vietnamese Dong' },
];

const STORAGE_KEY = 'farmworker_currency';
const DEFAULT_CURRENCY = 'USD';

export const getCurrency = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return CURRENCIES.find(c => c.code === stored) || CURRENCIES.find(c => c.code === DEFAULT_CURRENCY);
};

export const setCurrency = (code) => {
  localStorage.setItem(STORAGE_KEY, code);
  // Broadcast so other components re-render
  window.dispatchEvent(new CustomEvent('currency-changed', { detail: code }));
};

export const getCurrencySymbol = () => getCurrency().symbol;

export const formatCurrency = (amount, opts = {}) => {
  const currency = getCurrency();
  const value = Number(amount || 0);
  const decimals = opts.decimals ?? 0;
  const isNegative = value < 0;
  const absFormatted = Math.abs(value).toLocaleString(currency.locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${isNegative ? '-' : ''}${currency.symbol}${absFormatted}`;
};
